import React from 'react';
import { Checkbox, Typography } from '../../index';

interface IPlatePubliclyVisibleCheckbox {
	platePubliclyVisible: boolean;
	setPlatePubliclyVisible: (invoice: boolean) => void;
	label: string;
}

export const PlatePubliclyVisibleCheckbox = ({
	platePubliclyVisible,
	setPlatePubliclyVisible,
	label,
}: IPlatePubliclyVisibleCheckbox) => {
	const handleCheckboxToggle = (isChecked: boolean) => {
		setPlatePubliclyVisible(isChecked);
	};

	return (
		<>
			<Checkbox
				className="mb-4 pl-3"
				data-cy="button: platePubliclyVisible"
				id={`platePubliclyVisible`}
				label={
					<>
						<Typography component="p" color="title" variant="title">
							{label}
						</Typography>
					</>
				}
				title="platePubliclyVisible"
				checked={platePubliclyVisible}
				setChecked={handleCheckboxToggle}
			/>
		</>
	);
};
